import remoteServices from '~/constants/RemoteServices';
import designIcons from '~/constants/DesignIconConstants';
import {FOUNDRY_FONT_LIMIT} from '~/constants/FoundryConstants';
import {buildUrl} from '~/utils/url';
import Color from '~/data/records/Color';
import {isNone} from '~/data/accessors/color';

// NamesAndNumbers Icons need to be rendered at 1.25 their
// actual font height to match the legacy experience while
// keeping the coordinates correct.
export function computedFontHeight(fontHeight, type, scale, serverAction) {
  let computedFontHeight = Math.max(fontHeight * scale, 1);

  if (serverAction === 'info') {
    computedFontHeight = Math.ceil(computedFontHeight);
  }
  switch (type) {
    case 'NAMES':
    case 'NUMBERS':
      return computedFontHeight * 1.25;
    default:
      return computedFontHeight >= FOUNDRY_FONT_LIMIT
        ? FOUNDRY_FONT_LIMIT
        : computedFontHeight;
  }
}

export function textRequestBuilder(
  iconConfig,
  scale = 1,
  serverAction = 'gen',
  viewScaleFactor
) {
  const options = {
    ...getFontOptions(iconConfig, scale, serverAction, viewScaleFactor),
    ...getColorOptions(iconConfig),
    ...getAlignmentOptions(iconConfig),
    ...getRotationOptions(iconConfig),
    ...getOutlineOptions(iconConfig),
    ...getEffectOptions(iconConfig),
    ...getBoundingBoxOptions(iconConfig, scale)
  };

  const url = getFoundryUrl(serverAction);

  return buildUrl(url, options, 'op');
}

function getFontOptions(icon, scale, serverAction, viewScaleFactor) {
  const text = icon.value || '';
  const fontHeight = icon.fontHeight || designIcons.TEXT.DEFAULTS.FONT_HEIGHT;
  return {
    fnt: icon.font || designIcons.TEXT.DEFAULTS.FONT_NAME,
    ht: computedFontHeight(fontHeight, icon.type, scale, serverAction),
    sf: viewScaleFactor || scale,
    txt: text.replace(/\s*$/, '')
  };
}

function getColorOptions(icon) {
  const color = icon.color || {};
  return {
    r: color.r || 0,
    g: color.g || 0,
    b: color.b || 0
  };
}

function getBoundingBoxOptions(icon, scale) {
  const {fit, naturalWidth, naturalHeight} = icon;
  const fitToDimensions = fit === 'occupy';
  if (!fitToDimensions) {
    return {};
  }

  const options = {
    fit: fit,
    height: naturalHeight * scale,
    width: naturalWidth * scale
  };
  return options;
}

function getAlignmentOptions(icon) {
  return {
    a: icon.align || designIcons.TEXT.DEFAULTS.ALIGNMENT
  };
}
function getRotationOptions(icon) {
  return {
    ro: icon.rotation || designIcons.TEXT.DEFAULTS.ROTATION,
    lr: false
  };
}

function getOutlineOptions(icon) {
  return {
    ...getOutlineStrokeOptions(icon),
    ...getOutlineColorOptions(icon)
  };
}

function getOutlineStrokeOptions(icon) {
  const outlineOptions = {
    as: 1,
    st: icon.outlineWidth
  };
  return icon.outlineWidth ? outlineOptions : {};
}

function getOutlineColorOptions(icon) {
  const fillColor = new Color(icon.color || {});
  const outlineColor = icon.outlineColor || {};
  const colorOptions = {
    s_r: outlineColor.r || 0,
    s_g: outlineColor.g || 0,
    s_b: outlineColor.b || 0,
    cf: isNone(fillColor)
  };
  return icon.outlineColor ? colorOptions : {};
}

function getEffectOptions(icon) {
  const effectOptions = {
    ef: icon.effectType,
    efs: icon.effectSetting
  };
  return icon.effectType ? effectOptions : {};
}

function getFoundryUrl(action) {
  const host = remoteServices.foundry;
  return `${host}/${action}`;
}
